const PARENT_ROUTES = {
    login: '/',
    unauthorized: '/unauthorized',
    demo: '/demo',
    distributorManagement: '/distributors',
    managePricing: '/distributors/:accountNumber/managePricing',
    addDeviations: '/distributors/:accountNumber/managePricing/addDeviations',
    addDeviationsCatalog: '/distributors/:accountNumber/managePricing/addDeviations/catalog',
    addDeviationsExclusive: '/distributors/:accountNumber/managePricing/addDeviations/exclusive',
    addDeviationsPrivate: '/distributors/:accountNumber/managePricing/addDeviations/private',
    addDeviationsSetup: '/distributors/:accountNumber/managePricing/addDeviations/setup',
    addDeviationsConfirm: '/distributors/:accountNumber/managePricing/addDeviations/confirm',
    addProducts: '/distributors/:accountNumber/managePricing/addProducts',
    addProductsCatalog: '/distributors/:accountNumber/managePricing/addProducts/catalog',
    addProductsExclusive: '/distributors/:accountNumber/managePricing/addProducts/exclusive',
    addProductsPrivate: '/distributors/:accountNumber/managePricing/addProducts/private',
    addProductsSetup: '/distributors/:accountNumber/managePricing/addProducts/setup',
    addProductsConfirm: '/distributors/:accountNumber/managePricing/addProducts/confirm',
    tierSetUp: '/distributors/:accountNumber/managePricing/tierSetUp',
    approvals: '/approvals',
    tierOverrideApprovals: '/approvals/customerTierOverride',
    priceHistory: '/priceHistory',
    productManagement: '/productManagement',
    productManagementResults: '/productManagement/results/:massActionId',
    activePriceManagement: '/activePriceManagement',
    futurePriceManagement: '/futurePriceManagement',
    futureMarketPrices: '/futurePriceManagement/marketPrices',
    futureDeviations: '/futurePriceManagement/deviations',
    settings: '/settings',
};

export const ROUTES = {
    ...PARENT_ROUTES,
};
